export const isEmpty = <T>(object: T) => JSON.stringify(object) === '{}';
